import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  FormControl,
  TextField,
  Button,
  Paper,
  IconButton,
  Tooltip,
  Stack,
  useTheme,
  LinearProgress,
  Select,
  MenuItem,
  InputLabel,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import {
  fetchApidata,
  explorePostData,
  postData,
  getFetchData,
  requestMail,

} from "../../../store/reducers/Formapireducer";
import { Formik } from "formik";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import axios from "axios";

import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarDensitySelector,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import Swal from "sweetalert2";
import { useProSidebar } from "react-pro-sidebar";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import FileListPopup from "../../../ui-components/FIleViewDialog";
import FileUploadIconButton from "../../../ui-components/FileUploadButton";
import { attachmentPost } from "../../../store/reducers/LoginReducer";
import GradingIcon from '@mui/icons-material/Grading';
import ResetTvIcon from "@mui/icons-material/ResetTv";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { tokens } from "../../../Theme";
import store from "../../../index";
import { LoadingButton } from "@mui/lab";
import { fetchExplorelitview } from "../../../store/reducers/Explorelitviewapireducer";
import Listviewpopup from "../Lookup";
import Popup from "../popup";
import { toast } from "react-hot-toast";
import { Productautocomplete, CheckinAutocomplete } from "../../../ui-components/global/Autocomplete";
import { formGap } from "../../../ui-components/global/utils";
import { leaveAppoval, mailNotify } from "../../../store/reducers/Listviewapireducer";
import { fileUpload } from "../../../store/reducers/Imguploadreducer";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import CryptoJS from 'crypto-js';
// import ErrorMsgData from "../../Security/validationMsg.json"
import * as Yup from "yup";

// const validationSchema = Yup.object().shape({
//   ProName: Yup.object().required(ErrorMsgData.Onduty.ProName).nullable(),
//   LeavePart: Yup.string().required(ErrorMsgData.Onduty.LeavePart),
//   comment: Yup.string().required(ErrorMsgData.Onduty.comment),
//   FromDate: Yup.string().required(ErrorMsgData.Onduty.FromDate),
//   ToDate: Yup.string().required(ErrorMsgData.Onduty.ToDate),
// });

const KEY = CryptoJS.enc.Utf8.parse('1234567890123456'); // 16-byte key
const IV = CryptoJS.enc.Utf8.parse('1234567890123456');  // 16-byte IV


export function encryptDataUrlSafe(plainText) {
  const encrypted = CryptoJS.AES.encrypt(plainText, KEY, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString(); // Standard base64

  // Convert to URL-safe base64
  return encrypted.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function decryptData(encryptedBase64) {
  const decrypted = CryptoJS.AES.decrypt(
    { ciphertext: CryptoJS.enc.Base64.parse(encryptedBase64) },
    KEY,
    {
      iv: IV,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  );

  return decrypted.toString(CryptoJS.enc.Utf8); // Original string
}
const Editonduty = (empId, appId) => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const mode = params.Mode;
  const { toggleSidebar, broken, rtl } = useProSidebar();
  const listViewData = useSelector((state) => state.listviewApi.rowData);
  const listViewColumn = useSelector((state) => state.listviewApi.columnData);
  const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  const explorelistViewData = useSelector(
    (state) => state.exploreApi.explorerowData
  );
  const explorelistViewColumn = useSelector(
    (state) => state.exploreApi.explorecolumnData
  );
  const getLoading = useSelector((state) => state.formApi.getLoading);
  const data = useSelector((state) => state.formApi.Data);
  const isLoading = useSelector((state) => state.formApi.loading);
  const [pageSize, setPageSize] = useState(10);
  const [rowCount, setRowCount] = useState(0);
  const [show, setScreen] = React.useState("0");
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const Data = useSelector((state) => state.formApi.Data);
  const [openDEPopup, setOpenDEPopup] = useState(false);
  const [openADPopup, setOpenADPopup] = useState(false);
  const [openLETPopup, setOpenLETPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const EMPID = sessionStorage.getItem("EmpId");
  const compID = sessionStorage.getItem("companyId");
  const [showImage, setShowImage] = useState(params.Mode == "IM" ? true : false)
  var accessID = params.accessID;
 
  
  const SubscriptionCode = sessionStorage.getItem("SubscriptionCode");
  const is003Subscription = SubscriptionCode.endsWith("003");
  console.log(SubscriptionCode, is003Subscription, "SubscriptionCode");

 
 
  const exploreLoading = useSelector((state) => state.exploreApi.loading);
  const [error, setError] = useState('');
  const rowSx = { height: 36, '& td, & th': { py: 0.5 } };
  const [files, setFiles] = useState([]);
  const [errorMsgData, setErrorMsgData] = useState(null);
  const [validationSchema, setValidationSchema] = useState(null);

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/validationcms.json")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch validationcms.json");
        return res.json();
      })
      .then((data) => {
        setErrorMsgData(data);
        const schema = Yup.object().shape({

          ProName: Yup.object().required(data.Onduty.ProName).nullable(),
          LeavePart: Yup.string().required(data.Onduty.LeavePart),
          comment: Yup.string().trim().required(data.Onduty.comment),
          FromDate: Yup.string().required(data.Onduty.FromDate),
          ToDate: Yup.string().required(data.Onduty.ToDate),
          // managerComments: Yup.string().required(data.Onduty.managerComments),
        managerComments:
          mode === "M" ||
          (mode === "E" && (Data.Status === "RJ" || Data.Status === "QR"))
            ? Yup.string().required(
                data?.Onduty?.managerComments || "Manager Comments is required"
              )
            : Yup.string().notRequired(),
        Status: mode === "M" ? Yup.string().required(data.Onduty.Status) : Yup.string().notRequired(),
        
        });

        setValidationSchema(schema);
      })
      .catch((err) => console.error("Error loading validationcms.json:", err));
  }, [mode, Data.Status]);
  useEffect(() => {
    var url = store.getState().globalurl.empGetAttachmentUrl;

    axios
      .get(url, {
        params: {
          empId,
          appId
        }
      })
      .then((response) => {
        setFiles(response.data);
      })
      .catch((err) => {
        setError('Failed to fetch attachments.');
        console.error(err);
      })
      .finally(() => setLoading(false));

  }, [open, empId, appId]);
  const VISIBLE_FIELDS = ["SLNO", "Date", "NumberOfHours", "action"];
  const columns = React.useMemo(
    () =>
      explorelistViewColumn
        ? explorelistViewColumn.filter((column) =>
          VISIBLE_FIELDS.includes(column.field)
        )
        : [],
    [explorelistViewColumn]
  );
  const [selectedLeavetypeOptions, setSelectedLeavetypeOptions] =
    useState(null);
  const [selectedLeavetypeid, setSelectedLeavetypeid] = useState(null);
  const [selectedLeavetypeName, setSelectedLeavetypeName] = useState(null);
  // const validationSchema = Yup.object().shape({
  //   ProName: Yup.object()
  //     .nullable()
  //     .required("Project is required"),
  // });
  const handleSelectionLeavetypename = (newValue) => {
    if (newValue) {
      //Leavetype
      setSelectedLeavetypeOptions(newValue);
      console.log(newValue, "--setSelectedLeavetypeOptions");
      setSelectedLeavetypeid(newValue.RecordID);

      //setSelectedLeavetypeid(newValue.LeavetypeRecordID);
      setSelectedLeavetypeName(newValue.Name);
    } else {
      setSelectedLeavetypeOptions(null);
      setSelectedLeavetypeid(null);
      setSelectedLeavetypeName(null);
    }
  };
  var userimg = store.getState().globalurl.imageUrl;
  if (mode === "A" || !data?.ImageName) {
    userimg = userimg + "Defaultimg.jpg";
  } else {
    userimg = userimg + data.ImageName;
  }

  function handleShow(type) {
    if (type == "LT") {
      setOpenLETPopup(true);
    }
  }

  // const [isPopupData, setisPopupdata] = React.useState(false);
  const [opendesignPopup, setOpendesignPopup] = useState(false);

  const fnLogOut = (props) => {
    Swal.fire({
      title: errorMsgData.Warningmsg[props],
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") navigate("/");
        if (props === "Close") navigate(-1);
      }
    });
  };

  const dispatch = useDispatch();
  var recID = params.id;

  /*************************LOOKUP DATA*********************/
  const [openLTpopup, setOpenLTpopup] = useState(false);

  function handleShow(type) {
    if (type == "LT") {
      setOpenLTpopup(true);
    }
  }
  const [isPopupData, setisPopupdata] = React.useState(false);
  const [selectltLookupData, setselectLTLookupData] = React.useState({
    LTlookupID: "",
    LTlookupCode: "",
    LTlookupDesc: "",
  });

  if (isPopupData == false) {
    selectltLookupData.LTlookupID = Data.LeaveTypeID;
    selectltLookupData.LTlookupCode = Data.LeaveTypeCode;
    selectltLookupData.LTlookupDesc = Data.LeaveTypeName;
  }
  const childToParent = (childdata, type) => {
    console.log(childdata);

    if (type == "Leave Type") {
      setisPopupdata(true);
      setselectLTLookupData({
        LTlookupCode: childdata.Code,
        LTlookupID: childdata.RecordID,
        LTlookupDesc: childdata.Name,
      });
      setOpenLTpopup(false);
    }
  };

  //-------------------------------------LEAVE SAVE FUNCTION---------------------------------------------//

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [day, month, year] = dateStr.split("-");
    return `${year}-${month}-${day}`; // Converts "08-02-2025" to "2025-02-08"
  };
  const currentDate = new Date().toISOString().split("T")[0];
  const ondutyInitialValue = {
    applieddate: mode == "A" ? currentDate : data.AppliedDate,
    RecordID: Data.RecordID,
    FromDate: Data.FromDate,
    ToDate: Data.ToDate,
    LeavePart: Data.LeavePart,
    Status: mode === "M" ? "" : Data.Status,
    managerComments: mode == "M" ? Data.ManagerComments : "",
    comment: Data.Comments,
    ProName: Data.ProjectID
      ? { RecordID: Data.ProjectID, Code: Data.ProjectCode, Name: Data.ProjectName }
      : null,
    location: Data.Location,
    SortOrder: Data.SortOrder,
    Disable: Data.Disable,
  };

  console.log("Data:", Data);

  const ondutyFNsave = async (values, resetForm, del) => {
    setLoading(true);
    let action =
      mode === "A" && !del
        ? "insert"
        : mode === "E" && del
          ? "harddelete"
          : "update";
    const idata = {
      RecordID: recID,
      EmployeeID: mode == "M" ? params.parentID : EMPID,
      FromDate: values.FromDate,
      ToDate: values.ToDate,
      LeavePart: values.LeavePart,
      Comments: values.comment,
      ProjectID: values.ProName?.RecordID || 0,
      ProjectName: values.ProName.Name || "",
      // ProjectID: values.ProName? values.ProName.RecordID : 0,
      Location: values.location,
      Status:
        mode == "A"
          ? "AL"
          : mode == "E" && values.Status == "QR"
            ? "AL"
            : values.Status,
      ManagerComments: values.managerComments,
      AppliedDate: values.applieddate,
      SortOrder: "1",
      Disable: "N",
      Source: "Self",

      //   LeaveTypeID: values.leavetype.RecordID || 0,
    };

    const response = await dispatch(
      explorePostData({ accessID: "TR242", action, idata })
    );
    if (response.payload.Status == "Y") {
      if (mode == "A") {
        dispatch(
          requestMail({
            EmployeeID: EMPID,
            Type: "OD",
            RecordID: response.payload.OndutyRecid,
            encryptData: encryptDataUrlSafe(response.payload.OndutyRecid)

          })
        );
        dispatch(
          leaveAppoval({
            data: {
              RecordID: response.payload.OndutyRecid,
              ManagerID: "",
              EmployeeID: EMPID,
              Type: "OD",
              Status: "AL",
              Reason: values.comment,
            },
          })
        );
      }
      if (mode == "M") {
        dispatch(
          leaveAppoval({
            data: {
              RecordID: recID,
              ManagerID: EMPID,
              EmployeeID: params.parentID,
              Type: "OD",
              Status:
                values.Status == "AP"
                  ? "Y"
                  : values.Status == "QR"
                    ? values.Status
                    : "N",
              Reason: "",
              Source: "M",
            },
          })
        );
        dispatch(mailNotify({
          RecordID: recID,
          ManagerID: EMPID,
          EmployeeID: params.parentID,
          Type: "OD",
          Status:
            values.Status == "AP"
              ? "Y"
              : values.Status == "QR"
                ? values.Status
                : "N",
          Reason: "",
          Source: "M",

        }));
      }
      toast.success(response.payload.Msg);
      navigate(-1);
      resetForm();
    } else {
      setLoading(false);
      toast.error(response.payload.Msg);
    }
  };

  useEffect(() => {
    dispatch(getFetchData({ accessID, get: "get", recID })).then((res) => {
      var url = store.getState().globalurl.empGetAttachmentUrl;
      console.log(res, "response");
      axios
        .get(url, {
          params: {
            empId: data.EmployeeID,
            appId: recID
          }
        })
        .then((response) => {
          setFiles(response.data);
        })
        .catch((err) => {
          setError('Failed to fetch attachments.');
          console.error(err);
        })
        .finally(() => setLoading(false));
    })
  }, []);
  async function fileUpload(file, EMPID, action, id, purpose) {
    setLoading(true);
    console.log("🚀 ~ fileUpload ~ file:", file)
    const formData = new FormData();
    formData.append('file', file);
    formData.append('empId', Data.EmployeeID);
    formData.append('appId', Data.RecordID);
    formData.append('type', "OD");
    formData.append('source', "Self");
    formData.append("action", action);
    formData.append("id", id);
    formData.append("purpose", purpose ? purpose : "");
    console.log("🚀 ~ fileUpload ~ formData:", formData)
    const respose = await dispatch(attachmentPost({ data: formData }))

    if (respose.payload.success) {
      toast.success(respose.payload.message)
      var url = store.getState().globalurl.empGetAttachmentUrl;
      axios
        .get(url, {
          params: {
            empId: data.EmployeeID,
            appId: data.RecordID,

          }
        })
        .then((response) => {
          setFiles(response.data);
        })
        .catch((err) => {
          setError('Failed to fetch attachments.');
          console.error(err);
        })
        .finally(() => setLoading(false));
    } else {
      toast.success(respose.payload.message)
    }

    console.log("🚀 ~ fileUpload ~ respose:", respose)
  }
  return (
    <React.Fragment>
      {getLoading && <LinearProgress />}
      {loading && <LinearProgress />}
      <Paper elevation={3} sx={{ margin: "0px 10px", background: "#F2F0F0",height:"40px" }}>
        <Box display="flex" justifyContent="space-between" >
          <Box display="flex" borderRadius="3px" alignItems="center">
            {broken && !rtl && (
              <IconButton onClick={() => toggleSidebar()}>
                <MenuOutlinedIcon />
              </IconButton>
            )}
            <Typography variant="h3" sx={{ marginLeft: "10px", fontSize: "19px",color: "#0000D1" }} >
              
              {is003Subscription ? "Official Duty" : "On Duty"}
              </Typography>
          </Box>
          <Box display="flex">
            <Tooltip title="Close">
              <IconButton onClick={() => fnLogOut("Close")} color="error">
                <ResetTvIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Logout">
              <IconButton color="error" onClick={() => fnLogOut("Logout")}>
                <LogoutOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Paper>
      {!getLoading ? (
        //   <Box m="20px">
        <Paper elevation={3} sx={{ margin: "10px" }}>
          {mode === "IM" && (
            <Box
              display="flex"
              padding={1}
              justifyContent="flex-end"
              mt="2px"
              gridColumn="span 4"
              gap={2}
              //marginBottom={-5}
              mb={{ xs: -3, sm: -5, md: -5 }}

            >
              <IconButton
                onClick={() => setShowImage(prev => !prev)}
              >
                <ArrowDownwardIcon sx={{ color: "blue" }} />
              </IconButton>
            </Box>)}

          <Formik
            initialValues={ondutyInitialValue}
            enableReinitialize={true}
            validationSchema={validationSchema}
            onSubmit={(values, { resetForm }) => {
              setTimeout(() => {
                ondutyFNsave(values, resetForm, false);
              }, 100);
            }}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
              resetForm,
              setFieldValue,
            }) => (
              <form
                onSubmit={handleSubmit}
                onReset={() => {
                  // selectCellRowData({ rowData: {}, mode: "A", field: "" });
                  resetForm();
                }}
              >
                <Box
                  display="grid"
                  //   gap="30px"
                  gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                  gap={formGap}
                  padding={1}
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 4",
                    },
                  }}
                >
                  <FormControl sx={{ gridColumn: "span 2", gap: "15px" }}>
                    <TextField
                      name="applieddate"
                      type="date"
                      id="applieddate"
                      label="Applied Date"
                      variant="standard"
                      focused
                      inputFormat="YYYY-MM-DD"
                      value={values.applieddate}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={!!touched.applieddate && !!errors.applieddate}
                      helperText={touched.applieddate && errors.applieddate}
                      sx={{ gridColumn: "span 2" }}
                      InputLabelProps={{ shrink: true }}
                      inputProps={{
                        max: new Date().toISOString().split("T")[0],
                        readOnly: true,
                      }}
                      disabled={
                        mode === "M" || (
                          mode == "E" &&
                          values.Status != "AL" &&
                          values.Status != "RC"
                        )
                      }
                    />
                    {/* <FormControl
                      focused
                      variant="filled"
                      sx={{ gridColumn: "span 2" }}
                     
                    >
                      <InputLabel variant="standard" id="LeavePart">
                        
                      </InputLabel> */}
                    <TextField
                      labelId="demo-simple-select-filled-label"
                      fullWidth
                      label={
                        <span>
                          Day Part <span style={{ color: "red", fontSize: "20px" }}>*</span>
                        </span>
                      }
                      variant="standard"
                      type="text"
                      value={values.LeavePart}
                      id="LeavePart"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      name="LeavePart"
                      select
                      error={!!touched.LeavePart && !!errors.LeavePart}
                      helperText={touched.LeavePart && errors.LeavePart}

                      focused
                      disabled={
                        mode === "M" || (mode == "E" &&
                          values.Status != "AL" &&
                          values.Status != "QR")
                      }
                    >
                      <MenuItem value="FH">First Half</MenuItem>
                      <MenuItem value="SH">Second Half</MenuItem>
                      <MenuItem value="N">Full Day</MenuItem>
                    </TextField>
                    {/* </FormControl> */}
                    {!showImage ? <React.Fragment>
                      <TextField
                        disabled={
                          mode === "M" || (
                            mode == "E" &&
                            values.Status != "AL" &&
                            values.Status != "RC"
                          )
                        }
                        name="FromDate"
                        type="date"
                        id="FromDate"
                        label={
                          <span>
                            From Date <span style={{ color: "red", fontSize: "20px" }}>*</span>
                          </span>
                        }
                        //inputFormat="YYYY-MM-DD"
                        variant="standard"
                        focused
                        value={values.FromDate}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        // required
                        error={!!touched.FromDate && !!errors.FromDate}
                        helperText={touched.FromDate && errors.FromDate}

                        sx={{ gridColumn: "span 2" }}
                        InputLabelProps={{ shrink: true }}
                      />
                      <TextField
                        disabled={
                          mode === "M" || (
                            mode == "E" &&
                            values.Status != "AL" &&
                            values.Status != "QR"
                          )
                        }
                        name="ToDate"
                        type="date"
                        id="ToDate"
                        label={
                          <span>
                            To Date <span style={{ color: "red", fontSize: "20px" }}>*</span>
                          </span>
                        }
                        //inputFormat="YYYY-MM-DD"
                        variant="standard"
                        focused
                        value={values.ToDate}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        // required
                        error={!!touched.ToDate && !!errors.ToDate}
                        helperText={touched.ToDate && errors.ToDate}

                        sx={{ gridColumn: "span 2" }}
                        inputProps={{
                          min:
                            values.FromDate ||
                            new Date().toISOString().split("T")[0],
                        }}
                        InputLabelProps={{ shrink: true }}
                      />
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          gridColumn: "span 2",
                        }}
                      >
                        <CheckinAutocomplete
                          disabled={
                            mode === "M" || (
                              mode == "E" &&
                              values.Status != "AL" &&
                              values.Status != "QR"
                            )
                          }
                          name="ProName"
                          label={
                            <span>
                              Project <span style={{ color: "red", fontSize: "20px" }}>*</span>
                            </span>
                          }
                          id="ProName"
                          value={values.ProName}
                          onChange={(newValue) => {
                            setFieldValue("ProName", newValue);
                          }}
                          error={!!touched.ProName && !!errors.ProName}
                          helperText={touched.ProName && errors.ProName}
                          url={`${listViewurl}?data={"Query":{"AccessID":"2114","ScreenName":"Project","Filter":"parentID=${compID} AND EmployeeID=${EMPID}","Any":""}}`}
                        />
                      </Box>

                      <TextField
                        disabled={
                          mode === "M" || (
                            mode == "E" &&
                            values.Status != "AL" &&
                            values.Status != "QR"
                          )
                        }
                        name="location"
                        type="text"
                        id="location"
                        label="Location"
                        variant="standard"
                        focused
                        value={values.location}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.location && !!errors.location}
                        helperText={touched.location && errors.location}
                        // required
                        sx={{ gridColumn: "span 2" }}

                      />
                      <TextField
                        disabled={
                          mode === "M" || (
                            mode == "E" &&
                            values.Status != "AL" &&
                            values.Status != "QR"
                          )
                        }
                        name="comment"
                        type="comment"
                        id="comment"
                        label={
                          <span>
                            Work Details <span style={{ color: "red", fontSize: "20px" }}>*</span>
                          </span>
                        }
                        multiline
                        rows={6}
                        variant="outlined"
                        fullWidth
                        focused
                        // required
                        value={values.comment}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.comment && !!errors.comment}
                        helperText={touched.comment && errors.comment}
                        sx={{ gridColumn: "span 2" }}
                      />

                      {mode == "M" ||
                        (mode == "E" &&
                          (values.Status == "RJ" || values.Status == "QR")) ? (
                        <TextField
                          disabled={mode == "E" && values.Status != "AL"}
                          fullWidth
                          variant="outlined"
                          type="text"
                          // label="Manager Comments"
                          // required
                          label={
                            <>
                              Manager Comments
                              <span
                                style={{ color: "red", fontSize: "20px" }}
                              >
                                {" "}
                                *{" "}
                              </span>
                            </>
                          }
                          multiline
                          rows={6}
                          value={values.managerComments}
                          id="managerComments"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={
                            !!touched.managerComments &&
                            !!errors.managerComments
                          }
                          helperText={
                            touched.managerComments && errors.managerComments
                          }
                          name="managerComments"
                          sx={{
                            gridColumn: "span 2",
                          }}
                          focused
                        />
                      ) : (
                        false
                      )}

                      {mode == "M" && (
                        <TextField
                          select
                          label={
                            <>
                              Status<span style={{ color: "red", fontSize: "20px" }}> * </span>
                            </>
                          }
                          id="Status"
                          name="Status"
                          value={values.Status}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={!!touched.Status && !!errors.Status}
                          helperText={touched.Status && errors.Status}
                          focused
                          variant="standard"
                        >
                          {mode != "M" && <MenuItem value="AL">Applied</MenuItem>}
                          <MenuItem disabled={mode != "M"} value="AP">
                            Approved
                          </MenuItem>
                          <MenuItem disabled={mode != "M"} value="RJ">
                            Rejected
                          </MenuItem>
                          {mode == "M" && <MenuItem value="QR">Query</MenuItem>}
                        </TextField>
                      )}

                      {mode == "E" && values.Status == "AP" && (
                        <Alert variant="filled" sx={{ mt: 1 }} severity="success">
                          Your Onduty Request has been Approved.
                        </Alert>
                      )}
                      {mode == "E" && values.Status == "RJ" && (
                        <Alert variant="filled" sx={{ mt: 1 }} severity="error">
                          Your Onduty Request has been Rejected.
                        </Alert>
                      )}
                      {mode == "E" && values.Status == "QR" && (
                        <Alert variant="filled" sx={{ mt: 1 }} severity="warning">
                          Your Onduty Request has been Queried.
                        </Alert>
                      )}
                    </React.Fragment> : false}
                  </FormControl>

                  <Box
                    display="flex"
                    padding={1}
                    justifyContent="flex-end"
                    mt="2px"
                    gridColumn="span 4"
                    gap={2}
                  >
                    {/* {mode === "E" ? (
                      <Box display="flex" alignItems="center" gap={1}>
                        <FileUploadIconButton onFileSelect={fileUpload} />
                         </Box>
                    ) : null} */}
                    {/* 
                        <Tooltip title="View Uploaded Files">
                          <GradingIcon

                            onClick={() => setOpen(true)}
                            color="primary"
                            sx={{ cursor: 'pointer' }}
                          />
                        </Tooltip> */}

                    {/* {mode === "IM" ? (
                      <Button variant="contained" color="info" onClick={() => setShowImage(prev => !prev)}> {showImage ? 'Show Detail' : 'Hide Detail'}</Button>
                    ) : null} */}
                    {mode == "IM" && (
                      <>
                        <TextField
                          name="purpose"
                          type="text"
                          id="purpose"
                          label="Purpose"
                          variant="standard"
                          focused
                          value={values.purpose}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={!!touched.purpose && !!errors.purpose}
                          helperText={touched.purpose && errors.purpose}
                          sx={{ gridColumn: "span 2", height: "20px" }}
                          InputLabelProps={{ shrink: true }}

                        />

                        <Box display="flex" alignItems="center" gap={1}>
                          <FileUploadIconButton onFileSelect={(file) => {
                            fileUpload(
                              file,
                              data.EmployeeID,
                              "upload",
                              "",
                              values.purpose
                            )
                            setFieldValue("purpose", "");
                          }}
                          />
                        </Box>
                      </>
                    )}
                    {mode != "M" &&
                      (values.Status == "AL" ||
                        values.Status == "QR" ||
                        mode == "A") && (
                        <LoadingButton
                          disabled={mode == "IM"}
                          color="secondary"
                          variant="contained"
                          type="submit"
                          loading={isLoading}
                        >
                          Save
                        </LoadingButton>
                      )}
                    {mode == "M" && (
                      <LoadingButton
                        disabled={mode == "IM"}
                        color="secondary"
                        variant="contained"
                        type="submit"
                        loading={isLoading}
                      >
                        Save
                      </LoadingButton>
                    )}
                    {mode != "M" && values.Status == "AL" && (
                      <Button
                        color="error"
                        variant="contained"
                        disabled={mode == "IM"}
                        onClick={() => {
                          Swal.fire({
                            title: errorMsgData.Warningmsg.Delete,
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: "Confirm",
                          }).then((result) => {
                            if (result.isConfirmed) {
                              ondutyFNsave(values, resetForm, "harddelete");
                              // navigate(-1);
                            } else {
                              return;
                            }
                          });
                        }}
                      >
                        Delete
                      </Button>
                    )}
                    {mode == "M" && (
                      <Button
                        color="error"
                        variant="contained"
                        disabled={mode == "IM"}
                        onClick={() => {
                          Swal.fire({
                            title: `Do you want Delete?`,
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: "Confirm",
                          }).then((result) => {
                            if (result.isConfirmed) {
                              ondutyFNsave(values, resetForm, "harddelete");
                              // navigate(-1);
                            } else {
                              return;
                            }
                          });
                        }}
                      >
                        Delete
                      </Button>
                    )}
                    <Button
                      type="reset"
                      color="warning"
                      variant="contained"
                      onClick={() => {
                        navigate(-1);
                      }}
                    >
                      Cancel
                    </Button>
                    <FileListPopup
                      open={open}
                      onClose={() => setOpen(false)}

                      appId={recID}
                      empId={EMPID}
                    />
                    <Popup
                      title="Leave Type"
                      openPopup={openLTpopup}
                      setOpenPopup={setOpenLTpopup}
                    >
                      <Listviewpopup
                        accessID="2092"
                        screenName="Leave Type"
                        childToParent={childToParent}
                        filterName={"parentID"}
                        filterValue={compID}
                      />
                    </Popup>
                  </Box>
                </Box>
              </form>
            )}
          </Formik>
          {/* </Box> */}
        </Paper>
      ) : (
        false
        //      <Box display="flex" justifyContent="center" mt={4}>
        //    <Typography variant="h6" color="textSecondary">
        //      Loading data, please wait...
        //        </Typography>
        //  </Box>
      )}
      {mode === "IM" && files.length > 0 ? (
        <Box mt={2}
        >
          <Paper elevation={3} sx={{ padding: 2 }}>
            {/* <Typography variant="h6" gutterBottom>
              Uploaded Files
            </Typography> */}
            <TableContainer component={Paper} >
              <Table size="small">
                <TableHead>
                  <TableRow sx={rowSx}>
                    <TableCell width={20}><strong>SL#</strong></TableCell>
                    <TableCell ><strong>Uploaded Date</strong></TableCell>
                    <TableCell><strong>Filename</strong></TableCell>
                    <TableCell><strong>Purpose</strong></TableCell>
                    <TableCell ><strong>Source</strong></TableCell>
                    <TableCell><strong>View</strong></TableCell>


                  </TableRow>
                </TableHead>
                <TableBody>
                  {files.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={4} align="center">
                        No files uploaded yet.
                      </TableCell>
                    </TableRow>
                  ) : (
                    files.map((file, index) => (
                      <TableRow key={file.id || index} sx={rowSx}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{file.uploadedDate}</TableCell>
                        <TableCell>{file.filename}</TableCell>
                        <TableCell>{file.purpose}</TableCell>
                        <TableCell>{file.source}</TableCell>
                        <TableCell>
                          <Tooltip title="Open File">
                            <IconButton
                              color="primary"
                              component="a"
                              href={file.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              size="small"
                            >
                              <OpenInNewIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="delete">
                            <IconButton
                              color="error"
                              onClick={() => fileUpload(
                                file.filename,
                                Data.EmployeeID,
                                "delete",
                                file.id,
                                file.purpose
                              )}
                              size="small"
                            >
                              <DeleteForeverIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </TableCell>

                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Box>
      ) : null}
    </React.Fragment>
  );
};

export default Editonduty;
